import React, { useRef, useEffect, useState } from 'react';
import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover';
import { Button } from '@/components/ui/button';
import { X } from 'lucide-react';
import { TaskDetails } from './TaskDetails';

interface MaintenanceChartPopoverProps {
  isPopoverOpen: boolean;
  onPopoverClose: () => void;
  popoverPosition: Record<string, number>;
  selectedTask?: any;
}

export const MaintenanceChartPopover = ({
  isPopoverOpen,
  onPopoverClose,
  popoverPosition,
  selectedTask,
}: MaintenanceChartPopoverProps) => {
  const triggerRef = useRef<HTMLDivElement>(null);
  const [open, setOpen] = useState(isPopoverOpen);

  useEffect(() => {
    setOpen(isPopoverOpen);
  }, [isPopoverOpen]);

  const secondaryWorkOrderId = selectedTask?.[5]?.secondaryWorkOrderId
    ? `(${selectedTask?.[5]?.secondaryWorkOrderId})`
    : '';
  const workOrderNumber = `Work Order ${selectedTask?.[5]?.workOrderId} ${secondaryWorkOrderId ?? ''}`;

  return (
    <Popover
      open={open}
      onOpenChange={(val) => {
        setOpen(val);
        if (!val) onPopoverClose();
      }}
    >
      <PopoverTrigger asChild>
        <div
          ref={triggerRef}
          style={{
            position: 'absolute',
            top: popoverPosition.y,
            left: popoverPosition.x,
            width: 1,
            height: 1,
            visibility: 'hidden',
            zIndex: 50,
          }}
        />
      </PopoverTrigger>

      <PopoverContent
        className="border border-gray-300 bg-white p-4 shadow-xl w-[300px]"
        side="top"
        align="start"
        style={{ position: 'absolute' }}
      >
        <div className="flex justify-between items-center mb-2">
          <h4 className="text-sm font-semibold">{workOrderNumber}</h4>
          <Button variant="ghost" size="icon" onClick={onPopoverClose}>
            <X className="h-4 w-4" />
          </Button>
        </div>
        <div>{selectedTask?.[5] ? <TaskDetails details={selectedTask[5]} /> : null}</div>
      </PopoverContent>
    </Popover>
  );
};
